<div class="responsive-card d-flex flex-column gap-4">
  <div class="responsive-card-title" i18n>Recurring Payments</div>

  <ng-container *ngIf="isUnchanged && submission.new; else comparisonView">
    <app-update-vb-config-recurring-payment-review-card
      [data]="submission.new"
      [estimatedAnnualTotal]="newEstimatedAnnualTotal" />
  </ng-container>

  <ng-template #comparisonView>
    <div *ngIf="showCurrentCard && submission.previous" class="d-flex flex-column gap-3">
      <span class="label-sm" i18n>Current</span>
      <app-update-vb-config-recurring-payment-review-card
        [data]="submission.previous"
        [showAsCurrentState]="true"
        [subtitle]="currentSubtitle" />
    </div>

    <div *ngIf="submission.new" class="d-flex flex-column gap-3">
      <span class="label-sm" i18n>New</span>
      <app-update-vb-config-recurring-payment-review-card
        [data]="submission.new"
        [showAsNewState]="true"
        [subtitle]="newSubtitle"
        [newJurisdictionKeys]="newJurisdictionKeys"
        [estimatedAnnualTotal]="newEstimatedAnnualTotal" />
    </div>
  </ng-template>
</div>
